import React from 'react';

const ThirdDoubleByHeightHeader = (props) => {
  return (
    <th className="th-base" key={props.key}>
      <div className="th-content th-double-checkbox-content" style={{ width: props.column.width }}>
        <div className="th-content-upper">{props.column.upperHeader}</div>
        <div className="th-content-down">
          <div className="down-left-content">{props.column.downLeftHeader}</div>
          <div className="down-right-content">{props.column.downRightHeader}</div>
        </div>
      </div>
    </th>
  );
};

const gridHeaderTemplates = {
  thirdDoubleByHeightHeader: ThirdDoubleByHeightHeader
};

export default gridHeaderTemplates;



// WEBPACK FOOTER //
// ./src/common/core/grid/gridHeaderTemplates.js